import React, {useState} from 'react'
import Close from '../../Assets/Icons/cross.svg';
import {ProductModel} from "../../Models/ProductModel";
import BottomSheet from "../BottomSheet/BottomSheet";
import './CrossSelling.scss'
import CrossSellingItem from "../CrossSellingItem/CrossSellingItem";
import BaseButton from "../BaseButton/BaseButton";
import {OrderModel, OrderProductModel} from "../../Models/OrderModel";
import {useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {useGetDiscount} from "../../hooks/useGetDiscount";
import {useUpdatePanier} from "../../hooks/useUpdatePanier";
import {useCreateOrderWithPercentDiscount} from "../../hooks/useCreateOrderWithPercentDiscount";
import {useCreateOrderWithQuantityDiscount} from "../../hooks/useCreateOrderWithQuantityDiscount";
import {useCreateOrderWithoutDiscount} from "../../hooks/useCreateOrderWithoutDiscount";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

interface Props {
    show: boolean,
    close?: () => void
    products: ProductModel[]
}

interface ProductToAddModel {
    id: number,
    product: ProductModel,
    quantity: number,
}

const CrossSelling: React.FC<Props> = ({show, close, products}: Props) => {
    const {t} = useTranslation(['crossSelling', 'common'])
    const navigate = useNavigate()

    const userLoged = useSelector<StateModel, boolean>(state => state.user?.id !== undefined)
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)

    const [productsToAdd, setProductsToAdd] = useState<ProductToAddModel[]>([])

    const getDiscount = useGetDiscount()
    const updatePanier = useUpdatePanier()
    const createOrderWithPercentDiscount = useCreateOrderWithPercentDiscount()
    const createOrderWithQuantityDiscount = useCreateOrderWithQuantityDiscount()
    const createOrderWithoutDiscount = useCreateOrderWithoutDiscount()

    const addItem = (product: ProductModel) => {
        const newProductsToAdd = [...productsToAdd]
        newProductsToAdd.push({
            id: product.product.id,
            product,
            quantity: 1
        })
        setProductsToAdd(newProductsToAdd)
    }

    const addQuantity = (product: ProductModel) => {
        const newProductsToAdd = [...productsToAdd]
        const index = newProductsToAdd.findIndex(p => p.id === product.product.id)
        if(index !== -1) {
            const newProductToAdd = newProductsToAdd[index]
            newProductToAdd.quantity ++
            newProductsToAdd[index] = newProductToAdd
        }
        setProductsToAdd(newProductsToAdd)
    }

    const removeQuantity = (product: ProductModel) => {
        const newProductsToAdd = [...productsToAdd]
        const index = newProductsToAdd.findIndex(p => p.id === product.product.id)
        if(index !== -1) {
            const newProductToAdd = newProductsToAdd[index]
            newProductToAdd.quantity --
            if(newProductToAdd.quantity === 0) {
                newProductsToAdd.splice(index)
            } else {
                newProductsToAdd[index] = newProductToAdd
            }
        }
        setProductsToAdd(newProductsToAdd)
    }

    const getProductToAddQuantity = (product: ProductModel): number => {
        return productsToAdd.find(p => p.id === product.product.id)?.quantity ?? 0
    }

    const addToCart = (productToAdd: ProductToAddModel) => {
        const newPanier: OrderModel = panier ? {...panier} : {}
        if(!newPanier.orderProducts) {
            newPanier.orderProducts = []
        }
        let productToPush: OrderProductModel
        const discount = getDiscount(productToAdd.product.automaticDiscounts, new Date())
        if(discount) {
            if(discount.discount.type === "quantity") {
                productToPush = createOrderWithQuantityDiscount(productToAdd.product, discount, productToAdd.quantity, newPanier.orderProducts)
            } else {
                productToPush = createOrderWithPercentDiscount(productToAdd.product, discount, productToAdd.quantity)
            }
        } else {
            productToPush = createOrderWithoutDiscount(productToAdd.product, productToAdd.quantity)
        }
        newPanier.orderProducts.push(productToPush)
        updatePanier(newPanier)
    }

    const handlePaiementClick = () => {
        productsToAdd.forEach(p => {
            addToCart(p)
        })
        navigate(userLoged ? '/paiement' : '/commande')
    }

    return (
        <BottomSheet show={show} close={close}>
            <div className="crossSelling">
                <div className="crossSelling__header">
                    <p className="crossSelling__header--title">{t('crossSelling:title')}</p>
                    <div className="crossSelling__header__close">
                        <img src={Close} alt={t('common:alt.close')} onClick={close}/>
                    </div>
                </div>
                <div className="crossSelling__items">
                    {
                        products.map((p,i) => (
                            <CrossSellingItem
                                item={p}
                                key={i}
                                onAddItem={() => addItem(p)}
                                quantity={getProductToAddQuantity(p)}
                                onPlus={() => addQuantity(p)}
                                onMoins={() => removeQuantity(p)}
                            />
                        ))
                    }
                </div>
                <div className="crossSelling__btn">
                    <BaseButton text={t('common:actions.payment')} onClick={handlePaiementClick} />
                </div>
            </div>
        </BottomSheet>
    )
}

export default CrossSelling